import { useEffect, useRef, useState } from "react";
import type { ReviewAnnotationType, ReviewCategory } from "../lib/types.js";
import { CATEGORY_LABELS, CATEGORY_ORDER } from "./constants.js";

/** Typed note/flag composer shared by the reading view and Book View. */
export function ComposerModal({
  type,
  selectedText,
  onCancel,
  onSave
}: {
  type: ReviewAnnotationType;
  selectedText: string | null;
  onCancel: () => void;
  onSave: (note: string, category: ReviewCategory | null) => void;
}) {
  const [note, setNote] = useState("");
  const [category, setCategory] = useState<ReviewCategory | null>(type === "flag" ? "continuity" : null);
  const ref = useRef<HTMLTextAreaElement>(null);
  useEffect(() => { ref.current?.focus(); }, []);
  const title = type === "comment" ? "Add comment" : type === "flag" ? "Flag passage" : "Scene note";
  const showCategory = type === "flag" || type === "comment";

  return (
    <div className="review-composer-backdrop" onMouseDown={onCancel}>
      <div className="review-composer card" onMouseDown={(e) => e.stopPropagation()}>
        <div className="review-composer-head">{title}</div>
        {selectedText && (
          <blockquote className="review-composer-quote">
            “{selectedText.length > 220 ? selectedText.slice(0, 220) + "…" : selectedText}”
          </blockquote>
        )}
        {showCategory && (
          <div className="review-cat-chips">
            {CATEGORY_ORDER.map((c) => (
              <button key={c} type="button"
                className={`review-cat-chip${category === c ? " active" : ""}`}
                onClick={() => setCategory(category === c ? null : c)}>
                {CATEGORY_LABELS[c]}
              </button>
            ))}
          </div>
        )}
        <textarea ref={ref} className="input review-composer-text" rows={4}
          placeholder={type === "flag" ? "Why flag this? (optional)" : "Your note…"}
          value={note} onChange={(e) => setNote(e.target.value)}
          onKeyDown={(e) => { if ((e.ctrlKey || e.metaKey) && e.key === "Enter") onSave(note, category); }} />
        <div className="row gap-2" style={{ justifyContent: "flex-end" }}>
          <button className="btn btn-sm btn-ghost" onClick={onCancel}>Cancel</button>
          <button className="btn btn-sm btn-primary" onClick={() => onSave(note, category)}>
            Save <kbd className="search-kbd">⌘↵</kbd>
          </button>
        </div>
      </div>
    </div>
  );
}
